import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import {
    Button,
    BUTTON_SEVERITIES,
    BUTTON_SIZES,
} from "../../../../common/components";
import { PermissionsGate } from "../../../../common/components/PermissionsGate";
import { FLOW_TYPES, STEPS } from "../../../set-up-spaces-flow/constants";
import { useSetUpSpacesStore } from "../../../set-up-spaces-flow/store";
import { IconPlus } from "../Icons";

const AddLocationButton = () => {
    const { t } = useTranslation("common");

    const menuLeft = useRef<Menu>(null);

    const { toggleVisibility, setFlowType, setStep, reset } =
        useSetUpSpacesStore();

    const openInitialFlow = () => {
        reset();
        setFlowType(FLOW_TYPES.INITIAL);
        setStep(STEPS.SET_COMPANY);
        toggleVisibility();
    };

    const openFlowForLocation = () => {
        reset();
        setFlowType(FLOW_TYPES.ADD_LOCATION);
        setStep(STEPS.SELECT_COMPANY);
        toggleVisibility();
    };

    const items: MenuItem[] = [
        {
            items: [
                {
                    label: t("company") || "",
                    command: openInitialFlow,
                },
                {
                    label: t("location") || "",
                    command: openFlowForLocation,
                },
            ],
        },
    ];

    return (
        <PermissionsGate>
            <Menu
                model={items}
                popup
                ref={menuLeft}
                id="add-location-menu"
                className="[&_.p-submenu-header]:p-0"
            />
            <Button
                label={t("new")}
                icon={<IconPlus className="block size-4" strokeWidth={2} />}
                size={BUTTON_SIZES.SMALL}
                severity={BUTTON_SEVERITIES.NEUTRAL}
                text
                className="text-base [&_.p-button-label]:font-normal pl-2.25 pr-3 gap-1.25 text-primary-text! bg-transparent! border-transparent! hover:bg-surface-500/15! focus:shadow-none focus-visible:bg-surface-500/15"
                onClick={(event) => menuLeft.current?.toggle(event)}
                aria-controls="add-location-menu"
                aria-haspopup
            />
        </PermissionsGate>
    );
};

export default AddLocationButton;
